import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzS1612 } from './pages'

type TIdToPageMapWoofzS1612 = Record<PageIdWoofzS1612, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_S1_6_12: TIdToPageMapWoofzS1612 = {
  [PageId.DOG_BREED_S1_6_12]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({ default: m.DogBreedQuestion })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageId.DOG_AGE_S1_6_12]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/questions/dog-age/DogAgeQuestion'
      ).then((m) => ({ default: m.DogAgeQuestion })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/questions/dog-age/DogAgeQuestion'
      ),
  },
  [PageId.SHELTER_S1_6_12]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/questions/dog-shelter/DogShelterQuestion'
      ).then((m) => ({ default: m.DogShelterQuestion })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/questions/dog-shelter/DogShelterQuestion'
      ),
  },
  [PageId.COMMANDS_S1_6_12]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/questions/commands/DogCommands'
      ).then((m) => ({ default: m.DogCommands })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/questions/commands/DogCommands'
      ),
  },
  [PageId.SUBSCRIPTIONS_S1_6_12]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/subscriptions/SubscriptionsS1612'
      ).then((m) => ({ default: m.SubscriptionsS1612 })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/subscriptions/SubscriptionsS1612'
      ),
  },
  [PageId.CHAT_UPSELL_S1_6_12]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/upsell/ChatUpsellNewFlowS1612'
      ).then((m) => ({ default: m.ChatUpsellNewFlow })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/upsell/ChatUpsellNewFlowS1612'
      ),
  },
  [PageId.UPSELL_1_S1_6_12]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/upsell/Upsell'
      ).then((m) => ({ default: m.Upsell })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_s/woofz_s1_6_12/pages/upsell/Upsell'),
  },
  [PageIdWoofzS1612.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageId.DOWNLOAD_S1_6_12]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/download-app/DownloadApp'
      ).then((m) => ({ default: m.DownloadApp })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_s/woofz_s1_6_12/pages/download-app/DownloadApp'
      ),
  },
}
